type ShapeIconProps = {
  shapeName?: string | null;
  color?: string;
};

const ShapeIcon = ({ shapeName, color }: ShapeIconProps) => {
  return (
    <svg viewBox="0 0 80 80">
      <use href={`#${shapeName}`} color={color} fill={color} stroke="black" />
    </svg>
  );
};

export { ShapeIcon };
